import type { Metadata, MetadataNoCounts } from '#dn-types/api.ts';
import { PaginationControls } from '../pagination-controls/PaginationControls.tsx';
import { ResultsPerPage } from '../results-per-page/ResultsPerPage.tsx';
import type { PageSize } from '../types.ts';

type Props = {
  entityType: string;
  pageSize: PageSize;
  onPageSizeChange: (pageSize: PageSize) => void;
  isFetching: boolean;
  metadata: Metadata | MetadataNoCounts;
  setCursor: (cursor?: string) => void;
};

export const SMALLEST_PAGE_SIZE = 15;

/**
 * {@link TableFooter} provides pagination controls and a page size selector for use with a table.
 */
export function TableFooter({ isFetching, metadata, setCursor, pageSize, onPageSizeChange, entityType }: Props) {
  return (
    <div className="flex justify-between width-100">
      <PaginationControls
        isFetching={isFetching}
        metadata={metadata}
        onNextPage={() => {
          setCursor(metadata.nextCursor);
        }}
        onPrevPage={() => {
          setCursor(metadata.prevCursor);
        }}
        entityType={entityType}
      />
      <ResultsPerPage className="align-self-end" value={pageSize} onSelect={onPageSizeChange} />
    </div>
  );
}
